<template>
    <div
        v-if         = "isRouteView"
        class        = "placeholder-view has-requests"
        v-bind:class = "{ 'has-no-route-description' : !placeholder.routeDescription && isRouteView }"
    >
        <div v-bind:title="placeholder.routeDescription">
            <i class="material-icons" title="Routenstichpunkt">filter_hdr</i>

            <template v-if="placeholder.routeDescription">
                <template v-if="placeholder.timeOfDay">{{ getValueWithKey({ key: placeholder.timeOfDay, optionList: timeOfDay }) }} </template>

                {{ placeholder.routeDescription }}
                </template>
            <template v-else>ohne Routenbeschreibung</template>

            <div v-bind:class="['route-difficulty', getDifficulty()]" v-tooltip.top="{ content: placeholder.additionalDescription }">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
            </div>
        </div>


        <div class="is-60" v-if="!isConcept"></div>


        <div class="is-100 is-hidden-on-small">
            <location-charges
                v-bind:row="placeholder"
                v-bind:value="placeholder.locationCharges"
            />
        </div>


        <div class="contingent-section" v-if="!isConcept">
            <template v-if="placeholder.predefinedRouteDetail && placeholder.predefinedRouteDetail.pricePerPerson && placeholder.predefinedRouteDetail.pricePerPerson.amount && placeholder.predefinedRouteDetail.pricePerPerson.amount !== '0' && placeholder.predefinedRouteDetail.pricePerPerson.amount !== '0.00'">
                <span class="currency">{{placeholder.predefinedRouteDetail.pricePerPerson.currency}}</span>
                {{ placeholder.predefinedRouteDetail.pricePerPerson.amount | priceView }}
            </template>
            <template v-if="placeholder.pricePerPerson && placeholder.pricePerPerson.amount && placeholder.pricePerPerson.amount !== '0' && placeholder.pricePerPerson.amount !== '0.00'">
                <span class="currency">{{placeholder.pricePerPerson.currency}}</span>
                {{ placeholder.pricePerPerson.amount | priceView }}
            </template>
        </div>

        <div v-if="!isConcept">
            <location-charges
                v-bind:row="placeholder"
                v-bind:value="placeholder.locationCharges"
            />
        </div>


        <div class="action-buttons"><slot></slot></div>

        <div
            v-if="placeholder.sortGroup"
            class="group-icon"
            v-bind:class="'is-' + placeholder.sortGroup"
        ></div>
    </div>
</template>



<script>
import { priceView }       from '@utilities/functions';
import { LocationCharges } from '@components/CRUD/Table/Cells'
import mixins              from './mixins';


export default {
    mixins: [mixins],


    computed: {
        timeOfDay: function () { return this.$store.state.options.timeOfDay; }
    },


    methods: {
        getDifficulty: function () {
            if (this.placeholder.difficulty        === 'simple') { return 'has-1';

            } else if (this.placeholder.difficulty === 'medium') { return 'has-2';

            } else if (this.placeholder.difficulty === 'hard')   { return 'has-3';

            } else { return 'is-hidden'; }
        }
    },


    filters: {
        priceView
    },


    components: {
        LocationCharges
    }
}
</script>
